import NavBar from '../components/NavBar'
import HeroSection from '../components/DataManagementOptimization/HeroSection'
import Footer from '../components/Footer'
import ProcessSection from '../components/DataManagementOptimization/ProcessSection'
import TechStackMarquee from '../components/DataManagementOptimization/TechStackMarquee'
import ContactMap from '../components/ContactMap'

const DataManagementOptimization = () => {
	return (
		<div className="min-h-screen">
			<NavBar />
			<HeroSection />
			<ProcessSection />
			<TechStackMarquee />
			<ContactMap />
			<Footer />
		</div>
	)
}

export default DataManagementOptimization